import { requestJSON } from './request'
import { User } from './user'
import dayjs from 'dayjs'

// as required by Django (https://docs.djangoproject.com/en/1.10/ref/settings/#datetime-input-formats)
// NB: years with less than four digits are not properly formatted: https://github.com/iamkun/dayjs/issues/1237
type DjangoDate = string
export function toDjangoDate (date: Date): DjangoDate {
  return dayjs(date).format('YYYY-MM-DD HH:mm')
}

export interface Location {
  pk: number
  title: string
  address: string
  postal_code: string
  city: string
  mappable_location: string
  room: null
  place_id: string
  lat: string
  lon: string
}

export interface CreateLocation {
  lat: number
  lon: number
  address: string
  postal_code: string
  city: string
  title: string
  place_id: string
}

export const newLocation = (): CreateLocation => ({
  lat: 0,
  lon: 0,
  address: '',
  postal_code: '',
  city: '',
  title: '',
  place_id: ''
})

export interface CreateEvent {
  title: string
  description: string
  start: DjangoDate
  end: DjangoDate
  location: CreateLocation
  content: string
  // submitted for review (true) or saved as draft (false)
  submitted: boolean
}

export interface Event {
  title: string
  description: string
  content: string
  user: User
  slug: string
  pk: number
  start: string
  end: string
  location: Location
  published: boolean
  status?: number
}

export interface CreateEventResp {
  object_url: string
}

export async function getEvents (): Promise<Event[]> {
  return await requestJSON('/api/events/')
}

export async function getGuestEvents (): Promise<Event[]> {
  return await requestJSON('/api/guest-events/')
}

export async function getEvent (eventId: number): Promise<Event> {
  return await requestJSON(`/api/events/${eventId}/`)
}

export async function getEventAbortable (eventId: number, controller: AbortController): Promise<Event> {
  return await requestJSON(`/api/events/${eventId}/`, { signal: controller.signal })
}

export async function getGuestEvent (eventId: number): Promise<Event> {
  return await requestJSON(`/api/guest-events/${eventId}/`)
}

export async function getGuestEventAbortable (eventId: number, controller: AbortController): Promise<Event> {
  return await requestJSON(`/api/guest-events/${eventId}/`, { signal: controller.signal })
}

export async function createEvent (body: CreateEvent): Promise<CreateEventResp> {
  return await requestJSON('/api/guest-events/', { method: 'POST', body })
}

export async function editEvent (eventId: number, body: CreateEvent): Promise<void> {
  await requestJSON(`/api/guest-events/${eventId}/`, { method: 'PUT', body })
}

export async function deleteEvent (eventId: number): Promise<void> {
  await requestJSON(`/api/guest-events/${eventId}/`, { method: 'DELETE' })
}
